var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "d-flex flex-column justify-center align-sm-center height-100x overflow-auto width-100",
    },
    [
      _c(
        "div",
        {
          staticClass: "height-100x py-10",
          staticStyle: { "max-width": "520px" },
        },
        [
          _c("div", { staticClass: "text-center mb-6" }, [
            _c("h1", { staticClass: "mb-2" }, [_vm._v("Forgot password")]),
            _c("div", { staticClass: "text-body-2" }, [
              _vm._v("Verify your mobile phone to reset your password."),
            ]),
            _vm.maskedPhone && _vm.hasCodeBeenSent
              ? _c("div", { staticClass: "text-caption mt-2" }, [
                  _vm._v("Code sent to " + _vm._s(_vm.maskedPhone)),
                ])
              : _vm._e(),
          ]),
          _c("base-form", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ invalid }) {
                  return [
                    _c(
                      "v-card",
                      { staticClass: "mb-4", attrs: { flat: "" } },
                      [
                        _c(
                          "v-card-text",
                          [
                            _c("h3", { staticClass: "mb-3" }, [
                              _vm._v("Account verification"),
                            ]),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c("base-text-field", {
                                      attrs: {
                                        name: "loginId",
                                        label: "Login ID",
                                        value: _vm.loginId,
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          _vm.loginId = $event
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c("PhoneNumberInputComponent", {
                                      attrs: {
                                        value: _vm.phoneNumber,
                                        name: "phoneNumber",
                                        rules: "required",
                                        label: "Mobile Phone",
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          _vm.phoneNumber = $event
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "d-flex align-center",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "base-btn",
                                      {
                                        attrs: { disabled: _vm.resendDisabled },
                                        on: { click: _vm.requestCode },
                                      },
                                      [_vm._v(_vm._s(_vm.sendCodeButtonText))]
                                    ),
                                    _vm.hasCodeBeenSent && _vm.resendDisabled
                                      ? _c(
                                          "div",
                                          { staticClass: "ml-2 text-caption" },
                                          [
                                            _vm._v(
                                              "Resend in " +
                                                _vm._s(_vm.resendCountdown) +
                                                "s"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-card",
                      { staticClass: "mb-5", attrs: { flat: "" } },
                      [
                        _c(
                          "v-card-text",
                          [
                            _c("h3", { staticClass: "mb-3" }, [
                              _vm._v("Enter verification code"),
                            ]),
                            _c(
                              "v-row",
                              [
                                _c("v-col", { attrs: { cols: "12" } }, [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-center" },
                                    _vm._l(
                                      _vm.verificationCodeDigits,
                                      function (digit, index) {
                                        return _c("v-text-field", {
                                          key: index,
                                          ref: `verificationDigit${index}`,
                                          refInFor: true,
                                          staticClass: "mr-2",
                                          staticStyle: { "max-width": "52px" },
                                          attrs: {
                                            value: digit,
                                            maxlength: "1",
                                            outlined: "",
                                            "hide-details": "",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.handleCodeInput(
                                                index,
                                                $event
                                              )
                                            },
                                            keydown: function ($event) {
                                              return _vm.handleCodeKeydown(
                                                index,
                                                $event
                                              )
                                            },
                                            paste: function ($event) {
                                              return _vm.handleCodePaste($event)
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]),
                                _c(
                                  "v-col",
                                  {
                                    staticClass:
                                      "d-flex align-center justify-space-between",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "base-btn",
                                      {
                                        attrs: { text: "" },
                                        on: { click: _vm.goToSignin },
                                      },
                                      [_vm._v("Back to sign in")]
                                    ),
                                    _c(
                                      "base-btn",
                                      {
                                        attrs: {
                                          color: "rgb(115, 141, 202)",
                                          disabled:
                                            invalid ||
                                            !_vm.isVerificationCodeComplete,
                                        },
                                        on: {
                                          click: _vm.verifyCodeAndContinue,
                                        },
                                      },
                                      [_vm._v(" Continue ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }